import type { ApiFileUploadType } from '#/api/types/ApiFileUploadType';
import { postJson } from '#/utils/http/postJson';

import type { ApiPresignedFileUpload } from './types/ApiPresignedFileUpload';

type Args = {
  file: File;
  fileType: ApiFileUploadType;
};

export async function apiCreateS3PresignedUpload({ file, fileType }: Args) {
  return postJson<ApiPresignedFileUpload>('/data/s3-uploads', {
    fileType,
    filename: file.name,
    size: file.size, // bytes
    mimeType: file.type,
  });
}
